import { stories } from './cardData';

export const divacs = {
  currentStoryId: '1',
  stories: stories.filter((story) => story.id !== '1'),

  heroContent: {
    title: 'Scaling DIVACS With DIGU',
    subtitle:
      'Unifying value as the central point of the continuous business lifecycle',
    description:
      'DIVACS is a forward-thinking B2B SaaS platform dedicated to streamlining customer journey management by integrating customer lifecycle efforts, identifying ICPs (Ideal Customer Profiles), and closing deals efficiently. Built with a focus on delivering measurable outcomes, DIVACS empowers businesses to align operations with customer needs while driving efficiency and growth.',
    buttonText: 'More about DIVACS',
    buttonLink: 'https://www.divacs.com/',
    image: require('@/assets/img/divacs-cover.svg'),
    navIndicator: [
      { text: 'Home', icon: 'fas fa-home', link: '/' },
      { text: 'Customer Stories', link: '/customers' },
      { text: 'Scaling DIVACS With DIGU', link: '' },
    ],
  },
  tocSections: [
    { title: 'Key Stats', link: '#key-stats' },
    { title: 'The Challenge', link: '#the-challenge' },
    {
      title: 'The Solution: DIGU’s Staff Augmentation Service',
      link: '#the-solution',
    },
    { title: 'The Results', link: '#the-results' },
    {
      title: 'Impact Beyond Business: Empowering Nepal’s Tech Ecosystem',
      link: '#impact',
    },
    { title: 'Talent Testimonial', link: '#testimonial' },
    { title: 'Founder Testimonial', link: '#founder-testimonial' },
    // { title: 'More Stories', link: '#more-stories' },
  ],
  keyMetrics: [
    { label: 'Service', value: 'Staff Augmentation', color: '#FFD1D1' },
    {
      label: 'Service Type',
      value: 'Engineering & Design Services',
      color: '#D1E5FF',
    },
    { label: 'Time to Onboard', value: '35 to 40 days', color: '#D1E5FF' },
    { label: 'Cost Savings', value: 'Up to 70% Per Talent', color: '#D1E5FF' },
  ],
  challengeContent: {
    title: 'The Challenge',
    quote:
      'Product development is more than just coding; it’s about creating a platform that reflects our vision, meets customer expectations, and continuously adds value.',
    quoteAuthor: 'Ryan Schultz, founder of DIVACS, firmly believed:',
    description: [
      'When Ryan first envisioned DIVACS, he knew that building a successful platform required more than just a great idea. It meant balancing business development, finance, operations, and stakeholder management, all while ensuring continuous product development and customer-driven updates. ',
      'However, as Ryan worked to execute his plan, he quickly encountered major roadblocks:',
    ],
    roadblocks: [
      'Slow Time to Market: Without the right technical team, development timelines dragged, delaying product launches.',
      'Juggling Responsibilities: Managing multiple aspects of the business left little time for innovation and strategic growth.',
      'High Development Costs: Building a top-tier platform with U.S.-based developers was proving financially unsustainable.',
    ],
    order: 3,
    showQuote: true,
    showQuoteAuthor: true,
  },
  solutionContent: {
    title: 'The Solution',
    subtitle: "DIGU's Staff Augmentation Service",
    description: [
      'With DIGU’s Staff Augmentation Service, DIVACS transformed its vision into a scalable, adaptable platform primed for long-term success, enabling DIVACS to efficiently build a high-performing engineering and design team while staying focused on its core goals.',
      "Here's How:",
    ],
    benefits: [
      'Simplified Talent Search: DIGU provided a pre-screened pool of highly qualified engineers and designers, saving DIVACS time and resources on sourcing and initial screenings.',
      'Pre-Screened Interviews: DIVACS interviewed DIGU’s vetted candidates, selecting those best aligned with their vision and team needs.',
      'Annual Subscription Model: By choosing DIGU’s annual staff augmentation plan, DIVACS eliminated compensation, benefits, and administrative overhead, ensuring predictable costs and operational flexibility.',
    ],
  },
  resultsContent: {
    title: 'The Results',
    outcomes: [
      'Scalable, Cost-Effective Growth : By leveraging highly skilled Nepal-based engineers and designers, DIVACS reduced project costs by 60%, exceeding the industry benchmark of 30% savings.',
      "Time Savings for the Founder : 60% of Founder's time was freed up, allowing the team to have a greater focus on marketing, sales, and stakeholder relations.",
      'Significant Cost Savings in Staffing :  Hiring U.S.-based senior developers cost $200K–$300K annually, but DIVACS saves up to 70% per resource with DIGU, which covers benefits and compensation, ensuring a cost-effective solution.',
      'Optimized Talent Onboarding Process :  By onboarding 3 pre-vetted engineers and designers through DIGU, DIVACS saved up to $40,000 in recruitment costs. The entire onboarding process was completed in just 35–40 days, streamlining team expansion without the delays and expenses of traditional recruitment.',
      'Cultural & Ethical Alignment :  Studies show that 50%+ cultural alignment improves productivity and team cohesion. DIVACS reports over 70% alignment with DIGU’s Nepal-based team, ensuring seamless collaboration.',
    ],
    summary:
      'Today, DIVACS is being successful in building its brand equity by optimizing operations, reducing costs, and reclaiming valuable time for strategic growth. With an agile, high-performing development team, DIVACS is now well-positioned to scale efficiently, drive innovation, and continuously enhance customer experiences.',
    watermarkText: 'DIVACS',
    divacsColor: '#2196f3',
  },
  impactContent: {
    title: 'Impact Beyond Business: Empowering Nepal’s Tech Ecosystem',
    description:
      'DIGU is one of the most trusted and reliable professional IT service firms, delivering scalable, cost-effective solutions for SaaS startups and enterprises. However, our impact extends beyond business. Through the DIGU Grassroots Impact Initiative, every hire and project drives real change in Nepal’s tech community.',
    meterDescription:
      'Our Impact Meter provides clear insights into the measurable difference that DIVACS and DIGU have created in the Nepalese community.',
    categories: [
      {
        title: 'Job Creation',
        metrics: [
          { label: 'Professionals Onboarded by DIVACS', value: 3 },
          { label: 'Onboarded For DIGU', value: 1 },
          { label: 'Internal Entry Level Hired', value: 1 },
        ],
      },
      {
        title: 'Professional Development Programs',
        metrics: [
          { label: 'Communication Workshops Sponsored (10 People)', value: 1 },
          { label: 'Mentorship Program Sponsored', value: 1 },
          { label: 'Resume-Building Workshop Sponsored (10 People)', value: 2 },
        ],
      },
      {
        title: 'Scholarships & Education',
        metrics: [{ label: 'Scholarships Awarded', value: 1 }],
      },
      {
        title: 'Community Growth',
        metrics: [
          { label: 'Local Business Supported', value: 1 },
          { label: 'Educational Institutions Supported', value: 1 },
        ],
      },
      {
        title: 'Overall Grassroot Impact',
        highlightHeader: true,
        metrics: [
          { label: 'Families Supported', value: 7 },
          { label: 'Skilled Professionals Retained in Nepal', value: 5 },
          { label: 'Youth Retained for Higher Education', value: 1 },
        ],
      },
    ],
    showMeterDescription: true,
  },
  talentTestimonialContent: {
    title: 'Talent ',
    testimonials: [
      {
        name: 'Ujjwal Raja Maharjan',
        title: 'Senior Full Stack Engineer',
        hasImage: true,
        message:
          'Working at DIGU has been a truly rewarding and inspiring experience. The supportive work culture, flexibility, and balance between professional and personal growth have exceeded my expectations. DIGU promotes a collaborative environment where ideas are trusted, encouraged, and given space to grow, allowing us to take ownership with confidence. This combination of support, trust, and freedom keeps me motivated and enthusiastic about continuing my journey with DIGU.',
      },
      {
        name: 'Rubin Maharjan',
        title: 'Senior UI/UX Designer',
        hasImage: true,
        message:
          'I’m truly thankful to DIGU for helping me land full-time employment with a US-based company. Their recruitment process, which was both meticulous and smooth, opened the door for me to work with a diverse and talented global pool. I am grateful to the DIGU team for their unwavering commitment to advancing careers and their efforts in connecting professionals with opportunities worldwide. My career has been significantly transformed through their impact. As I move forward in my professional journey with the skills and confidence they’ve helped me develop, I look forward to the exciting opportunities ahead.',
      },
      {
        name: 'Shirish Parajuli',
        title: 'Frontend Developer',
        hasImage: true,
        message:
          'Being part of DIGU has been a rewarding journey for my career and personal growth. What I love most is that my ideas and words are truly valued; they’re not only heard but also supported and encouraged, which gives me the confidence to explore and grow further. The team here is so approachable and supportive, it’s easy to ask for guidance, share thoughts, and feel appreciated. The flexibility also makes a big difference, helping me balance work and life without feeling stressed. For me, DIGU isn’t just a workplace, it’s a place where I feel motivated, supported, and excited to keep learning and moving forward.',
      },
    ],
  },
  customerTestimonialContent: {
    title: 'Founder',
    testimonial: {
      name: 'Ryan Schultz',
      title: 'Founder & CEO at DIVACS, Inc.',
      message:
        'Working with DIGU has been an absolute pleasure. Their team of developers consistently impresses with their expertise, professionalism, and dedication to delivering top-notch solutions. Their innovative approach and attention to detail have greatly contributed to DIVACS’ success. Collaborating with DIGU has truly elevated our expectations, and I look forward to many more projects with them in the future.',
      image: require(`@/assets/img/ryan_schultz.webp`),
      linkedin: 'https://www.linkedin.com/in/ryanmschultz/',
    },
  },
};
